import { VendorVendorUsers as VendorVendorUsersComponent } from '../../../components/Vendor';

export function VendorVendorUsers() {
  return <VendorVendorUsersComponent />;
}
